
import CodeControllerAppService from "@/apis.machine/CodeControllerAppService";
import DtoFormCodeMethodGetPageList, {
  DtoFormCodeMethodGetPageListRules,
  DtoFormCodeMethodGetPageListMiezzFormItems,
} from "@/models.machine/DtoFormCodeMethodGetPageList";
import MiezzForm from "@/models/MiezzForm";
import MiezzModal from "@/models/MiezzModal";
import { Vue, Options } from "vue-class-component";
import { Emit, Prop, Watch } from "vue-property-decorator";
import CodeSelectForm from "./CodeSelectForm.vue";
import CodeDynamicSearchForm from "./CodeDynamicSearchForm.vue";
import CodePropertyTree from "../CodeDto/CodePropertyTree.vue";
import router from "@/router";
import CodeMethodAppService from "@/apis.machine/CodeMethodAppService";
import CodeDtoForm from "../CodeDto/CodeDtoForm.vue";
import { ElMessage } from "element-plus";
import TranslateAppService from "@/apis.machine/TranslateAppService";

@Options({
  components: {
    CodeSelectForm,
    CodeDynamicSearchForm,
    CodePropertyTree,
    CodeDtoForm,
  },
})
export default class CodeMethodPageListForm extends Vue {
  @Prop() id?: string;

  form = new MiezzForm<DtoFormCodeMethodGetPageList, string>();
  buttons = [
    {
      Code: "submit",
      Label: "保存",
      Type: "primary",
      Size: "small",
    },
  ];
  modal = new MiezzModal();
  drawerCode?: string;
  drawerFormData?: any;

  created(): void {
    this.form.Data = new DtoFormCodeMethodGetPageList();
    this.form.DefaultSpan = 12;
    this.form.Rules = DtoFormCodeMethodGetPageListRules;
    this.form.Items = DtoFormCodeMethodGetPageListMiezzFormItems;

    for (const item of this.form.Items) {
      switch (item.Prop) {
        case "Group":
          CodeControllerAppService.GetGroupSelect().then((r) => {
            item.Options = r.data.Data;
          });
          break;
        case "BaseService":
          CodeControllerAppService.GetBaseServiceSelect().then((r) => {
            item.Options = r.data.Data;
          });
          break;
        case "QueryableT":
          CodeControllerAppService.GetTableSelect().then((r) => {
            item.Options = r.data.Data;
          });
          break;
        case "IdType":
          item.AllowCreate = true;
          item.Options = [
            { Label: "Guid", Value: "Guid" },
            { Label: "string", Value: "string" },
            { Label: "int", Value: "int" },
            { Label: "long", Value: "long" },
          ];
          break;
        default:
          break;
      }
    }

    const query = router.currentRoute.value.query;
    if (query.Group) {
      this.form.Data.Group = query.Group as string;
      if (query.App) {
        this.form.Data.App = query.App as string;
        if (query.Service) {
          this.form.Data.Service = query.Service as string;
        }
      }
    }
  }

  @Watch("form.Data.Group")
  onGroupChanged(): void {
    const app = this.form.Items?.find((it) => it.Prop == "App");
    CodeControllerAppService.GetAppSelectByGroup(this.form.Data.Group).then((r) => {
      if (app && r.data.Data) {
        app.Options = r.data.Data;
        this.onAppChanged();
      }
    });
  }

  @Watch("form.Data.App")
  onAppChanged(): void {
    const service = this.form.Items?.find((it) => it.Prop == "Service");
    CodeControllerAppService.GetServiceSelectByGroupByApp(
      this.form.Data.Group,
      this.form.Data.App
    ).then((r) => {
      if (service && r.data.Data) {
        service.Options = r.data.Data;
        this.onServiceChanged();
      }
    });
  }

  @Watch("form.Data.Service")
  onServiceChanged(): void {
    const option = this.form.Items?.find(
      (it) => it.Prop == "Service"
    )?.Options?.find((it) => it.Value == this.form.Data.Service);
    let summary = "";
    if (option?.Data) {
      this.form.Data.QueryableT = option.Data.Table;
      this.form.Data.IdType = option.Data.IdType ? option.Data.IdType : "string";
      if (option.Data.Summary) {
        summary = option.Data.Summary;
        if (summary.indexOf("服务") > -1) {
          summary = summary.substr(0, summary.lastIndexOf("服务"));
        }
      }
    }
    this.form.Data.Summary = `获取${summary}分页列表`;
    if (this.form.Data.PageListSearch) {
      this.form.Data.PageListSearch.Name = `DtoPageListSearch${this.form.Data.Service}`;
      this.form.Data.PageListSearch.Summary = `${summary}分页列表-搜索条件`;
    }
    if (this.form.Data.PageList) {
      this.form.Data.PageList.Name = `DtoPageList${this.form.Data.Service}`;
      this.form.Data.PageList.Summary = `${summary}分页列表`;
    }
    if (this.form.Data.ListItem) {
      this.form.Data.ListItem.Name = `DtoListItem${this.form.Data.Service}`;
      this.form.Data.ListItem.Summary = `${summary}分页列表-项`;
    }
  }

  @Watch("form.Data.IdType")
  onIdTypeChanged(): void {
    if (this.form.Data.ListItem && this.form.Data.IdType) {
      this.form.Data.ListItem.BaseType = `UiListItem<${this.form.Data.IdType}>`;
      if (this.form.Data.ListItem.Name && this.form.Data.PageList)
        this.form.Data.PageList.BaseType = `UiPageList<${this.form.Data.ListItem.Name}, ${this.form.Data.IdType}>`;
    }
  }

  @Watch("form.Data.ListItem.Name")
  onListItemNameChanged(): void {
    if (
      this.form.Data.ListItem &&
      this.form.Data.ListItem.Name &&
      this.form.Data.IdType &&
      this.form.Data.PageList
    )
      this.form.Data.PageList.BaseType = `UiPageList<${this.form.Data.ListItem.Name}, ${this.form.Data.IdType}>`;
  }

  handleSubmit(): void {
    MiezzForm.submit(this.$refs, "ruleForm", (v) => {
      if (v) {
        CodeMethodAppService.AddGetPageListMethod(this.form.Data).then((r) => {
          ElMessage.success("添加成功");
          router.push("/developer/tool/controller");
        });
      }
    });
  }
}
